module.exports = __webpack_public_path__ + "img/logo_3.67cc5f98.png";